import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import colors from "../../../styles/colors";
import AppFrame from "../../Appframe/AppFrame";
import Title from "../../../components/common/Title";
import * as actionCreators from "../../../actions/apps";
import NPSScore from "../../../components/report/NPSScore";
import NPSScoreSmall from "../../../components/report/NPSScoreSmall";
import NSPService from "../../../services/nps";
import NPSReport from "../../../components/report/NPSReport";

const style = {};

class CSATRatingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportAppId: props.apps.providerAppId,
      percentPromoter: null,
      percentPassive: null,
      percentDemoter: null,
      responseList: null,
    };
  }

  componentWillMount() {
    try {
      NSPService()
        .getNPSScoresAndResponses(this.state.reportAppId)
        .then((resp) => {
          this.setState({
            score: resp.score,
            percentPromoter: resp.percentPromoter,
            percentPassive: resp.percentPassive,
            percentDetractor: resp.percentDetractor,
            responseList: resp.responseList,
          });
        })
        .catch((err) => {});
    } catch (ex) {
      console.log(ex);
    }
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }
    return (
      <AppFrame
        auth={this.props.auth}
        targetDevice={targetDevice}
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div>
          <Title
            text1="Net Promoter Score"
            text2="Report"
            goBack={() => this.props.history.goBack()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <NPSScore
              title="NPS Score"
              whiteLabelSettings={this.props.whiteLabelSettings}
              score={
                parseInt(this.state.percentPromoter, 10) -
                parseInt(this.state.percentDetractor, 10)
              }
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <NPSScoreSmall
              whiteLabelSettings={this.props.whiteLabelSettings}
              title="Detractors (0-6)"
              score={this.state.percentDetractor}
            />
            <NPSScoreSmall
              whiteLabelSettings={this.props.whiteLabelSettings}
              title="Passives (7-8)"
              score={this.state.percentPassive}
            />
            <NPSScoreSmall
              whiteLabelSettings={this.props.whiteLabelSettings}
              title="Promoters (9-10)"
              score={this.state.percentPromoter}
            />
          </div>
        </div>
        <div style={{ width: "75%", marginLeft: "auto", marginRight: "auto" }}>
          <NPSReport
            appId={this.state.reportAppId}
            reportData={this.state.responseList}
          />
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, whiteLabelSettings }) {
  return {
    user,
    apps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CSATRatingView);



// WEBPACK FOOTER //
// ./src/layout/reporting/ChannelLevel/NPSRatingView.js